import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useParams, useHistory } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
// @ts-ignore
import LazyLoad from "react-lazyload"

import { resetBookingState } from "../../actions/bookingActions"
import { resetSearch } from "../../actions/searchActions"
import {
  updateVisitLocation,
  locationToRegion,
} from "../../actions/locationActions"
import makeSlug from "../../utils/makeSlug"
import makeCityFromSlug from "../../utils/makeCityFromSlug"

import Layout from "../template-parts/product-marketing/Layout"
import Reviews from "../sections/Reviews"
import Contact from "../sections/Contact"
import MeetInstructors from "../sections/MeetInstructors"
import LocationContentSection from "../sections/LocationContent"
import PickupLocationBar from "../template-parts/PickupLocationBar"
import SearchLogicWrapper from "../template-parts/availability-picker/SearchLogicWrapper"
import { RootState } from "../../store/configureStore"

const Location = () => {
  const {
    state: urlState,
    id: locationId,
    type: lessonType,
  } = useParams<{ state?: string; id: string; type: string }>()
  const history = useHistory()
  const dispatch = useDispatch()

  const {
    location: { searchCity, searchState, stateConfig },
    firebase: { auth },
  } = useSelector((state: RootState) => state)

  const [city, setCity] = useState<string | null>(null)

  useEffect(() => {
    dispatch(resetBookingState())
    dispatch(resetSearch())
  }, [dispatch])

  useEffect(() => {
    if (!locationId) {
      setCity(null)
    }
  }, [locationId])

  useEffect(() => {
    if (searchState && searchCity && searchCity !== locationId) {
      history.push(
        `/${searchState.toLowerCase()}/location-search/${makeSlug(searchCity)}`,
      )
    }

    if (locationId) {
      setCity(makeCityFromSlug(locationId))
      dispatch(updateVisitLocation(locationId))

      if (window.google?.maps) {
        locationToRegion(locationId, urlState?.toUpperCase() || "CA")
      } else {
        // @ts-ignore-next-line
        window.scriptLoadedCallbackNames.push("locationCallback")
        // @ts-ignore-next-line
        window.locationCallback = locationToRegion(
          locationId,
          urlState?.toUpperCase() || "CA",
        )
      }
    }
  }, [dispatch, history, locationId, searchCity, searchState, urlState])

  const renderInstructors = () => (
    <LazyLoad height={400} offset={200} once>
      <MeetInstructors
        head={`Instructors serving ${city}`}
        location={city}
        state={searchState}
        doAlwaysShow={!!auth?.uid}
      />
    </LazyLoad>
  )

  const canonical =
    searchState && locationId
      ? `https://coastlineacademy.com/${searchState.toLowerCase()}/location/${locationId}`
      : undefined

  const titleLabel = city ? `${city} Driving School` : "Driving School"

  return (
    <>
      <Helmet>
        <title>{titleLabel}</title>
        <link rel="canonical" href={canonical} />
      </Helmet>
      <Layout>
        <PickupLocationBar />
        <SearchLogicWrapper
          lessonTypeName={lessonType}
          city={city || undefined}
          doRedirect={true}
        />
        {city ? (
          <div data-cy="instructors-lazyload">
            {renderInstructors()}
            <LocationContentSection
              city={city}
              hasFixedOrMeetingPoints={
                stateConfig?.hasFixedLocations ||
                stateConfig?.hasMeetingPoints ||
                false
              }
              hasHomePickup={stateConfig?.hasHomePickup || false}
            />
          </div>
        ) : null}
        <Reviews />
        <Contact />
      </Layout>
    </>
  )
}

export default Location
